"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableManagerListDefaultConfig = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../../Icon");
exports.tableManagerListDefaultConfig = [
    {
        Header: 'Name',
        accessor: 'displayName',
    },
    {
        Header: 'Email',
        accessor: 'email',
    },
    {
        Header: 'Balance',
        accessor: 'balance',
        disableSortBy: true,
    },
    {
        Header: () => 'Info',
        id: 'info',
        Cell: ({ row }) => {
            console.log('row', row);
            const manager = row.original;
            const modificators = manager.isActive ? ['primary'] : [];
            return (react_1.default.createElement("span", { className: 'table__action-icons' },
                react_1.default.createElement("span", { className: 'table__action-icon' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'edit' })),
                react_1.default.createElement("span", { className: 'table__action-icon' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'coins' })),
                react_1.default.createElement("span", { className: 'table__action-icon' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'list' })),
                react_1.default.createElement("span", { className: 'table__action-icon' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'eye', modificators: modificators })),
                react_1.default.createElement("span", { className: 'table__action-icon' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'x' }))));
        },
    },
];
//# sourceMappingURL=tableManagerListConfig.js.map